import { render, staticRenderFns } from "./FormVenta.vue?vue&type=template&id=70d4df5f&"
import script from "./FormVenta.vue?vue&type=script&lang=js&"
export * from "./FormVenta.vue?vue&type=script&lang=js&"
import style0 from "./FormVenta.vue?vue&type=style&index=0&id=70d4df5f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports